import { createContext, SetStateAction, useContext } from 'react'
import { Switch } from './components/switch'
import { useLocalStorage } from './use-local-storage'

const ValueContext = createContext<boolean | undefined>(undefined)
const SetterContext = createContext<
	((value: SetStateAction<boolean | undefined>) => void) | undefined
>(undefined)

export const useIgnoreRentner = () => {
	const value = useContext(ValueContext)
	if (value === undefined) {
		throw new Error('useIgnoreRentner must be used within a IgnoreRentnerProvider')
	}
	return value
}

export const useIgnoreRentnerSetter = () => {
	const value = useContext(SetterContext)
	if (value === undefined) {
		throw new Error('useIgnoreRentnerSetter must be used within a IgnoreRentnerProvider')
	}
	return value
}

export const IgnoreRentnerProvider = ({ children }: { children: React.ReactNode }) => {
	const [ignoreRentner, setIgnoreRentner] = useLocalStorage<boolean>('ignoreRentner', false)
	return (
		<SetterContext.Provider value={setIgnoreRentner}>
			<ValueContext.Provider value={ignoreRentner}>{children}</ValueContext.Provider>
		</SetterContext.Provider>
	)
}

export const IgnoreRentner = () => {
	const ignoreRentner = useIgnoreRentner()
	const setIgnoreRentner = useIgnoreRentnerSetter()
	return (
		<div>
			<Switch
				isSelected={ignoreRentner === true}
				onChange={setIgnoreRentner}
				label="Skrýt Rentner"
			/>
		</div>
	)
}
